export default function getStyleElements(namespace) {
  return Array.from(document.querySelectorAll(namespace ? "style[" + namespace + "]" : 'style'));
}